import { Counter, Link, Typography } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import { useNotificationsStore } from '@/stores/notifications';
import styles from './NotificationsHeader.module.css';

export const NotificationsHeader = () => {
  const { t } = useTranslation();
  const { notifications, deleteNotifications } = useNotificationsStore(
    (state) => ({
      notifications: state.getAppointmentNotifications(),
      deleteNotifications: state.deleteNotifications,
    }),
  );
  const counter = notifications.filter((item) => !item.readAt).length;

  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>
        <Typography
          as="h1"
          fontSize="20px"
          sx={{ lineHeight: '36px', fontWeight: '600' }}
        >
          {t('account-settings.notifications')}
        </Typography>
        <Counter count={counter} />
      </div>
      <Link
        text={t('common.clear-all')}
        color="black"
        preIcon="Eraser"
        weight="semibold"
        size="sm"
        disabled={notifications.length === 0}
        onClick={() => deleteNotifications()}
      />
    </div>
  );
};
